import { render, staticRenderFns } from "./DbMapIconForm.vue?vue&type=template&id=63968572"
import script from "./DbMapIconForm.vue?vue&type=script&lang=js"
export * from "./DbMapIconForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports